<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t('grnReport') }}</div>
      <div class="mt-3 mb-4">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label>{{ $tc('cinema', 1) }}</label>

              <b-dropdown variant="dropdown-curve" class="w-100">
                <b-dropdown-item></b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate">✖</button>
                <Datepicker :monday-first="true" ></Datepicker>
                <label>{{ $t("startdate") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class>
              <date-picker
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="Start Time"
              ></date-picker>
            </div>
            <!-- <p class="error_msg"></p> -->
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate">✖</button>
                <Datepicker :monday-first="true" ></Datepicker>
                <label>{{ $t("enddate") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class>
              <date-picker
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="End Time"
                name="showtime"
                id="showtime"
              ></date-picker>
            </div>
            <!-- <p class="error_msg"></p> -->
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label>{{ $tc('vendor', 1) }}</label>

              <b-dropdown variant="dropdown-curve" class="w-100">
                <b-dropdown-item></b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button class="btn-blue-lg w-100">{{ $t('getReport') }}</button>
          </div>
        </div>
      </div>

      <div class="swc-report" style="overflow-x: scroll;">
        <table class="swc-report-table" border="1" style="width: auto;">
          <thead class style="white-space: nowrap;">
            <tr class="bg-lightgrey">
              <th>No</th>
              <th>{{ $t('date') }}</th>
              <th>{{ $t('supplier') }} {{ $t('name') }}</th>
              <th>{{ $tc('rawmaterials', 1) }}</th>
              <th>UOM</th>
              <th>QTY</th>
              <th>{{ $t('rate') }}</th>
              <th>{{ $t('amount') }}</th>
              <th>{{ $t('remarks') }}</th>
              <th>{{ $t('inward') }} {{ $tc('user', 1) }}</th>
              <th>{{ $t('entered') }} On</th>
            </tr>
          </thead>
          <tbody class="sph-report" style="white-space: nowrap;">
            <tr>
              <td style="vertical-align: top;">1133</td>
              <td style="vertical-align: top;">01/04/2013</td>
              <td style="vertical-align: top;">A Grade Samosa</td>
              <td>Samosa Purchase</td>
              <td>Pack</td>
              <td>70,000</td>
              <td>14.18</td>
              <td>992.25</td>
              <td></td>
              <td style="vertical-align: top;">PRASHANT AMBETKAR</td>
              <td>01/04/2013 09:43 AM</td>
            </tr>
            <tr>
              <td style="vertical-align: top;">1134</td>
              <td style="vertical-align: top;">01/04/2013</td>
              <td style="vertical-align: top;">Royal Food & Beverage</td>
              <td>
                <div>Paneer Tikka Sandwich</div>
                <div>Veg & Cheese Sandwich</div>
                <div>Veg Burger</div>
                <div>Veg Cheese Burger</div>
              </td>
              <td>
                <div>No</div>
                <div>Nos</div>
                <div>Nos</div>
                <div>Nos</div>
              </td>
              <td>
                <div>2.000</div>
                <div>12.000</div>
                <div>5.000</div>
                <div>5.000</div>
              </td>
              <td>
                <div>25.00</div>
                <div>24.00</div>
                <div>28.00</div>
                <div>33.00</div>
              </td>
              <td>
                <div>50.00</div>
                <div>288.00</div>
                <div>140.00</div>
                <div>165.00</div>
              </td>
              <td></td>
              <td style="vertical-align: top;">PRASHANT AMBETKAR</td>
              <td>
                <div>01/04/2013 09:45 AM</div>
                <div>01/04/2013 09:45 AM</div>
                <div>01/04/2013 09:45 AM</div>
                <div>01/04/2013 09:45 AM</div>
              </td>
            </tr>
            <tr>
              <th></th>
              <th>Total</th>
              <th></th>
              <th></th>
              <th></th>
              <th>50,008.400</th>
              <th></th>
              <th>699,029.76</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";

export default {
  components: { DatePicker }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/grnReport.vue